<template>
 <!-- Main content -->
 <section class="content">
   <!-- Info boxes -->
   <div class="row">
     <div class="row" v-if="flag === 'br'">
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro in  orderBy(registros, 'labelPtBr')"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>
            <div class="info-box-content">
              <span class="info-box-text" >{{registro.labelPtBr}}</span>
              <span class="info-box-number" v-if="!registro.is_bool">{{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}<small> {{registro.unidade_medida}}</small></span>
              <span class="info-box-number" v-else-if="registro.valor">On</span>
              <span class="info-box-number" v-else>Off</span>
              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
              <span class="progress-description">
                {{registro.data_atualizacao}}
              </span>
           </div>
           <!-- /.info-box-content -->
         </div>  
       </div>
     </div>
     <div class="row" v-else-if="flag === 'de'">
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro in  orderBy(registros, 'labelDe')"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>
            <div class="info-box-content">
              <span class="info-box-text" >{{registro.labelDe}}</span>
              <span class="info-box-number" v-if="!registro.is_bool">{{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}<small> {{registro.unidade_medida}}</small></span>
              <span class="info-box-number" v-else-if="registro.valor">On</span>
              <span class="info-box-number" v-else>Off</span>
              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
              <span class="progress-description">
                {{registro.data_atualizacao}}
              </span>
           </div>
           <!-- /.info-box-content -->
         </div>  
       </div>
     </div>
     <div class="row" v-else-if="flag === 'us'">
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro in  orderBy(registros, 'labelEn')"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>
            <div class="info-box-content">
              <span class="info-box-text" >{{registro.labelEn}}</span>
              <span class="info-box-number" v-if="!registro.is_bool">{{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}<small> {{registro.unidade_medida}}</small></span>
              <span class="info-box-number" v-else-if="registro.valor">On</span>
              <span class="info-box-number" v-else>Off</span>
              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
              <span class="progress-description">
                {{registro.data_atualizacao}}
              </span>
           </div>
           <!-- /.info-box-content -->
         </div>  
       </div>
     </div>
     <div class="row" v-else>
        <div class="col-md-3 col-sm-6 col-xs-12" v-for="registro in  orderBy(registros, 'labelEs')"  :key="registro.id" v-if="registro.exibir">
          <div class="info-box bg-yellow">
            <span class="info-box-icon"><i :class="registro.icone"></i></span>
            <div class="info-box-content">
              <span class="info-box-text">{{registro.labelEs}}</span>
              <span class="info-box-number" v-if="!registro.is_bool">{{registro.valor | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}<small> {{registro.unidade_medida}}</small></span>
              <span class="info-box-number" v-else-if="registro.valor">On</span>
              <span class="info-box-number" v-else>Off</span>
              <div class="progress">
                <div class="progress-bar" style="width: 100%"></div>
              </div>
              <span class="progress-description">
                {{registro.data_atualizacao}}
              </span>
           </div>
           <!-- /.info-box-content -->
         </div>  
       </div>
     </div>
     <!-- /.col -->
     <!-- fix for small devices only -->
     <div class="clearfix visible-sm-block"></div>
   </div>
   <!-- /.row -->
   <div class="col-xs-12">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title"></h3>
          <div class="box-body">
            <div class="col-xs-12">
              <p class="text-center">
                <strong>{{producaoGraficoTitulo}}</strong>
              </p>
              <va-chart
                :chart-config='producaoGrafico' v-if="carregar"></va-chart>
            </div>
            <hr class="visible-xs-block">
          </div>
        </div>
      </div>
    </div>
   <!-- /.row -->

   <!-- Main row -->
   <div class="row">
   <!-- /.row -->
 </div>
 </section>
 <!-- /.content -->
</template>

<script>
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'
import VAChart from '../VAChart'

var db = firebaseApp.database()
var sd022020Ref = db.ref('sd022020')

export default {
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      registros: [],
      carregar: false,
      pesquisa: {
        titulo: 'titulo',
        parametro: 'DsPotenciaAcumuladaGerador',
        label: 'label'
      }
    }
  },
  components: {
    'va-chart': VAChart
  },
  firebase: {
    registros: sd022020Ref
  },
  methods: {
    track () {
      this.$ga.page('/')
    },
    createRelatorioGeracaoSeteDias (pesquisa) {
      this.$store.dispatch('createRelatorioGeracaoSeteDias', pesquisa)
        .then(response => {
          this.carregar = true
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted () {
    var bandeira = this.$store.state.flag
    switch (bandeira) {
      case 'de':
        this.pesquisa.titulo = 'KW/h produziert ab Tag'
        this.pesquisa.label = 'Akkumulierte Generatorleistung'
        break
      case 'us':
        this.pesquisa.titulo = 'KW/h produced from day'
        this.pesquisa.label = 'Accumulated Generator Power'
        break
      case 'es':
        this.pesquisa.titulo = 'KW/h producidos a partir del día'
        this.pesquisa.label = 'Potencia acumulada del generador'
        break
      default:
        this.pesquisa.titulo = 'KW/h produzidos a partir do dia'
        this.pesquisa.label = 'Potência Acumulada do Gerador teste'
        break
    }
    this.createRelatorioGeracaoSeteDias(this.pesquisa)
  },
  computed: {
    producaoGrafico () {
      return this.$store.state.Relatorios.historico
    },
    flag () {
      return this.$store.state.flag
    },
    producaoGraficoTitulo () {
      return this.$store.state.Relatorios.titulo
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?17c500c0